import { render, staticRenderFns } from "./colour.vue?vue&type=template&id=944f0950&scoped=true"
import script from "./colour.vue?vue&type=script&lang=js"
export * from "./colour.vue?vue&type=script&lang=js"
import style0 from "./colour.vue?vue&type=style&index=0&id=944f0950&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944f0950",
  null
  
)

export default component.exports